// extracted by mini-css-extract-plugin
export default {"dropdown":"ClientPortalConfigurationPage_dropdown__wGhab"};